import styled from 'styled-components';
import BlurredPic from '../../assets/img/blurred.png';

export const SliderContainer = styled.div`
  position: relative;

  height: 230px;
  margin-bottom: 20px;

  .swiper-container {
    height: 100%;
  }

  .swiper-pagination-bullet {
    width: 5px;
    height: 5px;
    margin: 0;

    background-color: ${({ theme }) => theme.white};
    opacity: 0.6;
  }

  .swiper-pagination-bullet-active {
    opacity: 1;
  }

  .swiper-container-horizontal > .swiper-pagination-bullets .swiper-pagination-bullet {
    margin: 0;

    &:not(:last-child) {
      margin-right: 3px;
    }
  }

  @media(min-width: 450px) {
    height: 300px;
  }

  @media(min-width: 768px) {
    height: auto;
    margin-bottom: 40px;

    .swiper-pagination {
      display: none;
    }

    .swiper-wrapper {
      display: grid;
      grid-template-rows: repeat(2, 115px);
      grid-gap: 2px;
      transform: none !important;

      ${({ amount }) => {
        switch(amount) {
          case 1:
            return null;
          case 2:
          case 3:
            return 'grid-template-columns: repeat(2, 1fr);';
          case 4:
          case 5:
            return 'grid-template-columns: repeat(3, 1fr);';
          default:
            return 'grid-template-columns: 50% repeat(4, 1fr);'
        }
      }
    };

    .swiper-pagination {
      display: none;
    }
  }

  .swiper-lazy-preloader {
    display: none;
    width: 106px;
    height: 106px;
    margin-top: -55px;
    margin-left: -55px;

    &::after {
      background: transparent no-repeat center / contain;
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='106' height='106' fill='none'%3E%3Cpath stroke='%23DADEE1' stroke-width='10' d='M53 101a48 48 0 1 0 0-96 48 48 0 0 0 0 96z' clip-rule='evenodd'/%3E%3Cpath stroke='%23fff' stroke-width='10' d='M5 53c0 27 21 48 48 48a48 48 0 1 0 0-96'/%3E%3C/svg%3E");
    }
  }

  @media(min-width: 1024px) {
    margin-bottom: 50px;

    .swiper-wrapper {
      grid-template-rows: repeat(2, 220px);
    }
  }
`;

export const Slide = styled.div`
  margin: 0;
  padding: 0;

  font-size: 0;

  background: transparent url(${BlurredPic}) no-repeat center / cover;

  img {
    width: 100%;
    height: 100%;

    object-fit: cover;
    pointer-events: none;
    user-select: none;

    &.swiper-lazy-loading {
      display: none;
    }

    &.swiper-lazy-loaded {
      display: block;
    }

    &[src=""] {
      display: none;
    }
  }

  @media(min-width: 768px) {
    width: auto !important;
    cursor: pointer;

    ${({ amount }) => {
      switch(amount) {
        case 2:
          return `
            &:nth-child(1) {
              grid-row: 1 / -1;
              grid-column: 1;
            }

            &:nth-child(2) {
              grid-row: 1 / -1;
              grid-column: 2;
            }
          `;
        case 3:
          return `
            &:nth-child(1) {
              grid-row: 1 / -1;
              grid-column: 1;
            }

            &:nth-child(2) {
              grid-row: 1;
              grid-column: 2;
            }

            &:nth-child(3) {
              grid-row: 2;
              grid-column: 2;
            }
          `;
        case 4:
          return `
            &:nth-child(1) {
              grid-row: 1 / -1;
              grid-column: 1;
            }

            &:nth-child(2) {
              grid-row: 1;
              grid-column: 2;
            }

            &:nth-child(3) {
              grid-row: 2;
              grid-column: 2;
            }

            &:nth-child(4) {
              grid-row: 1 / -1;
              grid-column: 3;
            }
          `;
        case 5:
          return `
            &:nth-child(1) {
              grid-row: 1 / -1;
              grid-column: 1;
            }

            &:nth-child(2) {
              grid-row: 1;
              grid-column: 2;
            }

            &:nth-child(3) {
              grid-row: 2;
              grid-column: 2;
            }

            &:nth-child(4) {
              grid-row: 1;
              grid-column: 3;
            }

            &:nth-child(5) {
              grid-row: 2;
              grid-column: 3;
            }
          `;
        default:
          return `
            &:nth-child(1) {
              grid-row: 1 / -1;
              grid-column: 1;
            }

            &:nth-child(2) {
              grid-row: 1;
              grid-column: 2 / 4;
            }

            &:nth-child(3) {
              grid-row: 1;
              grid-column: 4 / 5;
            }

            &:nth-child(4) {
              grid-row: 1;
              grid-column: 5 / 6;
            }

            &:nth-child(5) {
              grid-row: 2;
              grid-column: 2 / 4;
            }

            &:nth-child(6) {
              grid-row: 2;
              grid-column: 4 / 6;
            }
          `;
      }
    }
  }
`;

export const ShowAll = styled.button`
  position: absolute;
  z-index: 1;
  bottom: 10px;
  right: 20px;

  display: none;
  margin: 0;
  padding: 15px 35px;

  font-weight: 700;
  font-size: 12px;
  line-height: 1;
  color: ${({ theme }) => theme.blue};
  text-align: center;

  background-color: ${({ theme }) => theme.white};
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.24);
  border: none;
  border-radius: 50px;
  outline: none;

  cursor: pointer;

  @media(min-width: 768px) {
    display: block;
  }

  @media(min-width: 1024px) {
    bottom: 20px;
    right: 40px;

    font-size: 16px;
  }
`;

export const SliderWindow = styled.article`
  position: fixed;
  z-index: 15;
  top: 0;
  left: 0;

  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  height: 100%;
  padding: 95px 45px;

  background-color: #505050;
`;

export const CloseModalButton = styled.button`
  position: absolute;
  top: 20px;
  right: 20px;

  width: 31px;
  height: 31px;

  background: transparent no-repeat center / contain;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='33' height='33' fill='none'%3E%3Cpath fill='%23fff' stroke='%23fff' d='M31.63 1.37a1.25 1.25 0 0 0-1.77 0l-28.5 28.5a1.25 1.25 0 1 0 1.78 1.76l28.5-28.5c.48-.48.48-1.27 0-1.76z'/%3E%3Cpath fill='%23fff' stroke='%23fff' d='M31.63 29.86L3.13 1.36a1.25 1.25 0 1 0-1.76 1.78l28.5 28.5a1.25 1.25 0 0 0 1.76 0c.5-.5.5-1.29 0-1.78z'/%3E%3C/svg%3E");

  cursor: pointer;
`;


export const ModalSlider = styled.div`
  position: relative;
  height: 465px;

  .swiper-container {
    height: 100%;
    width: 680px;
    margin: 0 auto;
    padding-bottom: 45px;
  }

  .swiper-pagination-fraction {
    position: static;
    margin-top: 25px;

    font-size: 20px;
    line-height: 1;
    color: ${({ theme }) => theme.white};
    text-align: left;
  }

  .swiper-lazy-preloader {
    display: none;
    width: 106px;
    height: 106px;
    margin-top: -55px;
    margin-left: -55px;

    &::after {
      background: transparent no-repeat center / contain;
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='106' height='106' fill='none'%3E%3Cpath stroke='%23DADEE1' stroke-width='10' d='M53 101a48 48 0 1 0 0-96 48 48 0 0 0 0 96z' clip-rule='evenodd'/%3E%3Cpath stroke='%23fff' stroke-width='10' d='M5 53c0 27 21 48 48 48a48 48 0 1 0 0-96'/%3E%3C/svg%3E");
    }
  }

  @media(min-width: 1024px) {
    max-height: 835px;
    height: 100%;

    .swiper-container {
      width: auto;
    }
  }
`;

export const ModalSlide = styled.div`
  font-size: 0;
  text-align: center;
  user-select: none;

  & > div {
    max-width: 1150px;
    height: 100%;
    margin: 0 auto;

    background: transparent url(${BlurredPic}) no-repeat center / cover;
  }

  img {
    margin: 0 auto;
    min-width: 1150px;
    height: 100%;

    object-fit: cover;

    &.swiper-lazy-loading {
      display: none;
    }

    &.swiper-lazy-loaded {
      display: block;
    }

    &[src=""] {
      display: none;
    }
  }
`;

export const NavigationButton = styled.button`
  position: absolute;
  z-index: 5;
  top: 0;

  width: 21px;
  height: calc(100% - 45px);

  background: transparent no-repeat center / contain;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='21' height='36' fill='none'%3E%3Cpath fill='%23fff' d='M20.24 19.78L4.4 35.26c-1 .99-2.64.99-3.64 0-1.01-.98-1.01-2.58 0-3.56L14.77 18 .76 4.3C-.25 3.32-.25 1.72.76.74c1-.99 2.64-.99 3.64 0l15.84 15.48a2.48 2.48 0 0 1 0 3.56z'/%3E%3C/svg%3E");

  cursor: pointer;

  transition: opacity 0.3s;

  &[disabled] {
    opacity: 0;
    pointer-events: none;
  }

  &.modal-navigation--prev {
    transform: rotate(180deg);
    left: -35px;
  }

  &.modal-navigation--next {
    right: -35px;
  }
`;
